export default __webpack_public_path__ + "static/media/AXM-PKS-30902.ce4fc532.jpg";